import { Box, TextField, MenuItem, Button, Stack, InputAdornment } from '@mui/material';
import { Search, FilterX } from 'lucide-react';
import { DEPARTMENTS, DESIGNATIONS } from '@/mock/teachers';

export function TeacherFilter({ filter, onFilterChange, onReset }) {
  const handleChange = (field) => (event) => {
    onFilterChange({ ...filter, [field]: event.target.value });
  };

  return (
    <Box sx={{ p: 2, bgcolor: 'background.paper', borderRadius: 2, mb: 3 }}>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ alignItems: 'center' }}>
        <TextField
          size="small"
          placeholder="Search by name, employee ID..."
          value={filter.search || ''}
          onChange={handleChange('search')}
          fullWidth
          sx={{ flex: 1, minWidth: { xs: '100%', sm: 300 } }}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <Search size={18} />
                </InputAdornment>
              ),
            }
          }}
        />

        <TextField
          select
          size="small"
          label="Department"
          value={filter.department || ''}
          onChange={handleChange('department')}
          sx={{ minWidth: 150 }}
        >
          <MenuItem value="">All Departments</MenuItem>
          {DEPARTMENTS.map((dept) => (
            <MenuItem key={dept} value={dept}>{dept}</MenuItem>
          ))}
        </TextField>

        <TextField
          select
          size="small"
          label="Designation"
          value={filter.designation || ''}
          onChange={handleChange('designation')}
          sx={{ minWidth: 150 }}
        >
          <MenuItem value="">All Designations</MenuItem>
          {DESIGNATIONS.map((desig) => (
            <MenuItem key={desig} value={desig}>{desig}</MenuItem>
          ))}
        </TextField>

        <TextField
          select
          size="small"
          label="Status"
          value={filter.status || ''}
          onChange={handleChange('status')}
          sx={{ minWidth: 120 }}
        >
          <MenuItem value="">All Status</MenuItem>
          <MenuItem value="active">Active</MenuItem>
          <MenuItem value="inactive">Inactive</MenuItem>
        </TextField>

        <Button 
          variant="outlined" 
          startIcon={<FilterX size={18} />} 
          onClick={onReset}
          sx={{ whiteSpace: 'nowrap' }}
        >
          Clear Filters
        </Button>
      </Stack>
    </Box>
  );
}
